import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Promo from "../components/SAIRUS_NEW/Promo/Promo";
import About from "../components/SAIRUS_NEW/About/About";
import Technologies from "../components/SAIRUS_NEW/Technologies/Technologies";
import Opportunities from "../components/SAIRUS_NEW/Opportunities/Opportunities";
import WhatCan from "../components/SAIRUS_NEW/WhatCan/WhatCan";
import Social from "../components/SAIRUS_NEW/Social/Social";
import Roadmap from "../components/Roadmap";
import Investments from "../components/Investments";
import News from "../components/SAIRUS_NEW/News/News";
import Faq from "../components/SAIRUS_NEW/Faq/Faq";
import Footer from "../components/SAIRUS_NEW/Footer";
import AboutWrapper from "../components/SAIRUS_NEW/About/AboutWrapper";
import TechnologiesWrapper from "../components/SAIRUS_NEW/Technologies/TechnologiesWrapper";
import OpportunitiesWrapper from "../components/SAIRUS_NEW/Opportunities/OpportunitiesWrapper";
import WhatCanWrapper from "../components/SAIRUS_NEW/WhatCan/WhatCanWrapper";
import SocialWrapper from "../components/SAIRUS_NEW/Social/SocialWrapper";
import RoadmapWrapper from "../components/SAIRUS_NEW/Roadmap/RoadmapWrapper";
import InvestmentsWrapper from "../components/Investments/InvestmentsWrapper";
import NewsWrapper from "../components/SAIRUS_NEW/News/NewsWrapper";
import FaqWrapper from "../components/SAIRUS_NEW/Faq/FaqWrapper";
import FooterWrapper from "../components/SAIRUS_NEW/Footer/FooterWrapper";
import Cyborg from "../components/Cyborg/Cyborg";
import { useInView } from "react-intersection-observer";
import useMediaQuery from "../hooks/useMediaQuery";

const LandingPage = () => {
    const searchParams = useSearchParams();
    const matches = useMediaQuery("(min-width: 750px)");

    useEffect(() => {
        if (searchParams[0].get("ref")) {
            localStorage.setItem("ref", searchParams[0].get("ref") || "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Promo />
            <AboutWrapper />
            <TechnologiesWrapper />
            <OpportunitiesWrapper />
            <WhatCanWrapper />
            <SocialWrapper />
            <RoadmapWrapper />
            <InvestmentsWrapper />
            <NewsWrapper />
            <FaqWrapper />
            <FooterWrapper />
            {/* <About /> */}
            {/* <Technologies /> */}
            {/* <Opportunities /> */}
            {/* <WhatCan /> */}
            {/* <Social /> */}
            {/* <Roadmap /> */}
            {/* <Investments /> */}
            {/* <News /> */}
            {/* <Faq /> */}
            {/* <Footer /> */}
            {matches && <Cyborg />}
        </>
    );
};

export default LandingPage;
